require('./cart-item/cart-item.scss');
var BaseViews = require('../../base');
var Textbox = require('treeline-shared-components/textbox');
var StringUtils = require('../../../utils/strings');
var CartItemCountIncrementor = require('./cart-item-count-incrementor');
var CartItem = BaseViews.LayoutView.extend({
    className: 'fmcy-cart-item container-fluid',
    template: require('./cart-item/cart-item.html'),
    initialize: function(options) {
        var self = this;
        this.options = _.defaults(
            options || {},
            {
                theme: 'light'
            }
        );
        this.model.on('change:cartCount', function () {
          // check its not a number...
          var cartCount = parseInt(self.model.get('cartCount'));
          if (cartCount !== '') {
            self.trigger('cart:item:qty:updated');
          }
        });
    },
    regions: {
      itemImageRegion : '.fmcy-cart-item-image-region',
      cartCountInputRegion : '.fmcy-cart-count-input-region'
    },
    ui: {
      cartItemRemoveButton: '.fmcy-cart-item-remove-button',
      cartItemTotalText: '.cart-item-total-text',
      cartItemSavingsText: '.fmcy-cart-item-savings-text',
      errorMessage: '.fmcy-cart-item-error-message',
      itemImage: '.fmcy-cart-item-image-region',
      itemTitle: '.fmcy-cart-item-title'
    },
    triggers: {
      'click @ui.cartItemRemoveButton': 'delete:item',
      'click @ui.itemImage': 'click:item',
      'click @ui.itemTitle': 'click:item'
    },
    _updateItemTotal: function () {
      this.ui.cartItemTotalText.html(StringUtils.currency(parseFloat(this.model.get('item_sub_total'))));
      this.ui.cartItemSavingsText.html(this.getSavedText());
      this.maybeShowSavingsText();
    },
    _renderCountIncrementor: function () {
      var self = this;
      var cartItemCountIncrementor = new CartItemCountIncrementor({
        model: this.model
      });

      cartItemCountIncrementor.on('click:plus', function (view) {
        var cartCount = view.model.get('cartCount');
        cartCount += 1;
        self.model.set('cartCount', cartCount);
      });

      cartItemCountIncrementor.on('click:minus', function (view) {
        var cartCount = view.model.get('cartCount');
        if (cartCount !== 0) {
          cartCount -= 1;
          self.model.set('cartCount', cartCount);
        }
      });

      this.cartCountInputRegion.show(cartItemCountIncrementor);
    },
    _renderItemImage: function () {
      var itemImageRegion = new (require('../../product-tile/image-display'))({
        imageURL: this.model.get('thumb_url'),
        displayNoImageAvailableIcon: true
      });

      if (this.model.get('slug')) {
        this.ui.itemImage.css('cursor', 'pointer');
        this.ui.itemTitle.css('cursor', 'pointer');
      }

      this.itemImageRegion.show(itemImageRegion);
    },
    hideItem: function () {
      this.$el.hide();
    },
    maybeShowSavingsText: function () {
      if (this.model.get('group_discount_total') == 0) {
        this.ui.cartItemSavingsText.hide();
      } else {
        this.ui.cartItemSavingsText.show();
      }
    },
    onRender: function () {
      this._renderItemImage();
      this._renderCountIncrementor();
      this.maybeShowSavingsText();
      if (this.options.errors !== null &&
        this.options.errors.length > 0 &&
        this.model.get('error') === true) {
        var message;

        if (parseInt(this.model.get('actualCount')) == 0) {
          message = 'Out of stock, please remove.';
        } else if (parseInt(this.model.get('actualCount')) < parseInt(this.model.get('cartCount'))) {
          message = 'Only ' + parseInt(this.model.get('actualCount')) + ' available';
        } else {
          message = 'Problem, please remove.';
        }

        this.$el.addClass('fmcy-cart-item-error');
        this.ui.errorMessage.html(message);
      }
    },
    getSavedText: function () {
      return '- ' + StringUtils.currency(parseFloat(this.model.get('group_discount_total')));
    },
    onDestroy: function () {
      this.model.off('change:cartCount');
    },
    serializeData: function () {
      return {
        savedText: this.getSavedText(),
        cartItemTitle: this.model.get('title'),
        cartItemQuantityWeight:  this.model.get('quantity'),
        cartItemPrice: StringUtils.currency(this.model.getPrice()),
        itemTotal: StringUtils.currency(parseFloat(this.model.get('item_sub_total'))),
        cartCount: this.model.get('cartCount')
      }
    }
});

module.exports = CartItem;



/** WEBPACK FOOTER **
 ** ./assets/js/common/cart/cart-review/cart-item.js
 **/